import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import language from "#scripts/translation";
import { setImages } from "#scripts/images";

let _categoryId = 0;

export const getEvents = (categoriesapiId, listMode, callback) => {
	const calendarNameId = window.serverdata.configMeta.aim.calendar.group;
	const munic = window.serverdata.configMeta.aim.calendar.municipalities || "";
	fetch(
		`https://sspkalender.prokom.no/api/tidspunkt?Categories=${categoriesapiId}&SearchText=&DateFrom=&DateTo=&Municipalities=${munic}&Kunde=${calendarNameId}&Id=&ItemDate=&WeekDays=&List=${listMode ?? "compact"
		}&Count=100&Distributor=`,
	)
		.then((data) => data.json())
		.then((data) => {
			callback(data);
		});
};

export const getFilteredEvents = (categoriesapiId, fromDate, toDate, filter, listMode, callback) => {
	const calendarNameId = window.serverdata.configMeta.aim.calendar.group;
	const munic = window.serverdata.configMeta.aim.calendar.municipalities || "";
	fetch(
		`https://sspkalender.prokom.no/api/tidspunkt?Categories=${categoriesapiId}&SearchText=${filter}&DateFrom=${fromDate}&DateTo=${toDate}&Municipalities=${munic}&Kunde=${calendarNameId}&Id=&ItemDate=&WeekDays=&List=${listMode ?? "compact"
		}&Count=100&Distributor=`,
	)
		.then((data) => data.json())
		.then((data) => {
			callback(data);
		});
};

export const calendarpage = (categoryId) => {
	const urlParams = new URLSearchParams(window.location.search);
	const urlCategory = urlParams.get("category");
	_categoryId = categoryId;
	if (urlCategory !== null) _categoryId = urlCategory;

	document.title = language("START_CALENDAR");
	const breadcrumbs = `
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="fullnav__breadcrumb__container">
                    <nav aria-label="breadcrumb">
                        <ol class="aim-breadcrumb fullnav__breadcrumb" id="full__breadcrumb">
                        <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
                        <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("START_CALENDAR")}</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
    `;

	getEvents(_categoryId, window.serverdata.configMeta.aim.calendar.listMode, (cal) => {
		filterByCategory(_categoryId, "list");
		//setCalendarList(100, cal);
	});
	getCategories((_categories) => {
		const categorySelector = document.getElementById("filterCategory");
		const cats = _categories.Kategorier[0]?.UnderKategori || [];
		for (const catitem of cats) {
			// optgrp.value = catitem.Id;
			// optgrp.innerHTML = catitem.Navn;
			// categorySelector.appendChild(opt);
			const catHidden = window.serverdata.configMeta.aim.calendar?.hiddenCategories?.includes(catitem.Id) ?? false;
			if (!catHidden) {
				if (catitem?.UnderKategori?.length > 0) {
					const optgrp = document.createElement("optgroup");
					optgrp.label = catitem.Navn;
					for (const catsubitem of catitem.UnderKategori) {
						const opt = document.createElement("option");
						opt.value = catsubitem.Id;
						opt.innerHTML = `${catsubitem.Navn}`;
						optgrp.appendChild(opt);
					}
					categorySelector.appendChild(optgrp);
				} else {
					const opt = document.createElement("option");
					opt.value = catitem.Id;
					opt.innerHTML = `${catitem.Navn}`;
					categorySelector.appendChild(opt);
				}
			}
		}
		categorySelector.value = _categoryId;
		if (urlCategory === null) categorySelector.value = window.serverdata.configMeta.aim?.calendar?.localid;
		// setCalendarGrid(100, cal);
	});

	let newLinkButton = "";
	if (window.serverdata.configMeta.aim.calendar.possible_new) {
		let newlink = "https://sspkalender.prokom.no/Account/Login?returnUrl=%2Fkalenderregistrering%2FCreate%2F1121";
		if (window.serverdata.configMeta.aim?.calendar?.clientid) {
			newlink = `https://sspkalender.prokom.no/Account/Login?returnUrl=%2Fkalenderregistrering%2FCreate%2F${window.serverdata.configMeta.aim?.calendar?.clientid}`;
		}
		if (window.serverdata.configMeta.aim?.calendar?.new_link) {
			newlink = window.serverdata.configMeta.aim?.calendar?.new_link;
		}
		newLinkButton = `<a id="createNew" class="calendar__new" href="${newlink}" aria-label="Opprett arrangement (${language("NAV_OPEN_I_NEW")})" target="_blank">Opprett arrangement <span class="material-icons-outlined notranslate">open_in_new</span></a>`;
	}

	return `
        <section class="breadcrumbs">
          ${breadcrumbs}
        </section>
        <section class="filter">
          <div class="container p-md-0 calendar__event__container">
            <div class="row justify-content-md-center">
              <div class="col-12 col-md-8 p-md-0">
                <h1 class="calendar__content__title">${language("START_CALENDAR")}</h1>
              </div>
            </div>
            <div class="row justify-content-md-center calendar__filter">
              <div class="col-6 col-md-2 pl-md-0"><label for="fromDate">Dato fra</label><input type="date" id="fromDate" class="form-control" />
              </div>
              <div class="col-6 col-md-2"><label for="toDate">Dato til</label><input type="date" id="toDate" class="form-control" />
              </div>
              
              <div class="col-12 col-md-4 pr-md-0">
                <label for="filterCategory">${language("FILTER_SELECT_CATEGORY")}</label>
                <select id="filterCategory" class="form-control">
                  <option value="${window.serverdata.configMeta.aim?.calendar?.localid}">Alle kategorier</option>
                </select>
              </div>
              <div class="col-12 col-md-8 mb-3 pl-md-0 pr-md-0"><input type="text" id="filterText" class="form-control" placeholder="Søk etter tittel eller innhold" /></div>
              
              
              <!--div class="col-12 col-md-4 mb-3 pl-md-0 pr-md-0"><label for="filterText">&nbsp;</label><input type="text" id="filterText" class="form-control" placeholder="Søk etter tittel eller innhold" /></div-->
            </div>
            <div class="row justify-content-md-center calendar__filter">
              <div class="col-12 col-md-8 mb-3 p-md-0 d-flex flex-wrap">
                <button type="button" class="calendar__filter__button primary__button" id="btnSearchForEvents">Søk</button>
                <a id="resetLink" class="calendar__reset" href="#"><span class="material-icons-outlined notranslate">refresh</span>Nullstill</a>
                <span style="flex-grow:1;"></span>
                ${newLinkButton}
              </div>
            </div>
            <div class="row justify-content-md-center calendar__filter-end">
              <div class="col-12 m-0"></div>
            </div>
          <div>
        </section>
        <section class="content">
            <div class="container p-md-0" id="calendarlistcontainer">
            ...
            </div>
        </section>
    `;
};
export const calendarpageCustom = (categoryId) => {
	const urlParams = new URLSearchParams(window.location.search);
	const urlCategory = urlParams.get("category");
	_categoryId = categoryId;
	if (urlCategory !== null) _categoryId = urlCategory;

	document.title = language("START_CALENDAR");
	const breadcrumbs = `
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="fullnav__breadcrumb__container">
                    <nav aria-label="breadcrumb">
                        <ol class="aim-breadcrumb fullnav__breadcrumb" id="full__breadcrumb">
                        <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
                        <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("START_CALENDAR")}</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
    `;

	getEvents(categoryId, window.serverdata.configMeta.aim.calendar.listMode, (cal) => {
		filterByCategory(categoryId, "grid");
		// setCalendarGrid(100, cal);
	});
	getCategories((categories) => {
		const categorySelector = document.getElementById("filterCategory");
		const cats = categories.Kategorier[0].UnderKategori;
		for (const catitem of cats) {
			const catHidden = window.serverdata.configMeta.aim.calendar?.hiddenCategories?.includes(catitem.Id) ?? false;
			if (!catHidden) {
				if (catitem.UnderKategori.length > 0) {
					const optgrp = document.createElement("optgroup");
					optgrp.label = catitem.Navn;
					for (const catsubitem of catitem.UnderKategori) {
						const opt = document.createElement("option");
						opt.value = catsubitem.Id;
						opt.innerHTML = `${catsubitem.Navn}`;
						optgrp.appendChild(opt);
					}
					categorySelector.appendChild(optgrp);
				} else {
					const opt = document.createElement("option");
					opt.value = catitem.Id;
					opt.innerHTML = `${catitem.Navn}`;
					categorySelector.appendChild(opt);
				}
			}
		}
		categorySelector.value = _categoryId;
		if (urlCategory === null) categorySelector.value = window.serverdata.configMeta.aim?.calendar?.localid;
		// setCalendarGrid(100, cal);
	});

	let newLinkButton = "";
	if (window.serverdata.configMeta.aim.calendar.possible_new) {
		let newlink = "https://sspkalender.prokom.no/Account/Login?returnUrl=%2Fkalenderregistrering%2FCreate%2F1121";
		if (window.serverdata.configMeta.aim?.calendar?.clientid) {
			newlink = `https://sspkalender.prokom.no/Account/Login?returnUrl=%2Fkalenderregistrering%2FCreate%2F${window.serverdata.configMeta.aim?.calendar?.clientid}`;
		}
		newLinkButton = `<a id="createNew" class="calendar__new" href="${newlink}" ria-label="Opprett arrangement (${language("NAV_OPEN_I_NEW")})" target="_blank">Opprett arrangement <span class="material-icons-outlined">open_in_new</span></a>`;
	}

	return `
        <section class="breadcrumbs">
          ${breadcrumbs}
        </section>
        <section class="filter">
          <div class="container calendar__event__container">
            <div class="row justify-content-md-center">
              <div class="col-12 col-md-12">
                <h1 class="calendar__content__title">${language("START_CALENDAR")}</h1>
              </div>
            </div>
            <!--
            <div class="row justify-content-md-center calendar__filter">
              <div class="col-6 col-md-3"><label for="fromDate">Dato fra</label><input type="date" id="fromDate" class="form-control" />
              </div>
              <div class="col-6 col-md-3"><label for="toDate">Dato til</label><input type="date" id="toDate" class="form-control" />
              </div>
              <div class="col-12 col-md-6">
                <label for="filterCategory">${language("FILTER_SELECT_CATEGORY")}</label>
                <select id="filterCategory" class="form-control">
                  <option value="0">Alle kategorier</option>
                </select>
              </div>
              <div class="col-12 col-md-12 mb-3"><input type="text" id="filterText" class="form-control" placeholder="Søk etter tittel eller innhold" /></div>
            </div>
            <div class="row justify-content-md-center calendar__filter">
              <div class="col-12 col-md-12 mb-3 d-flex flex-wrap">
                <button type="button" class="calendar__filter__button primary__button" id="btnSearchForEvents">Søk</button>
                <a id="resetLink" class="calendar__reset" href="#"><span class="material-icons-outlined notranslate">refresh</span>Nullstill</a>
                <span style="flex-grow:1;"></span>
                ${newLinkButton}
              </div>
            </div>
            <div class="row justify-content-md-center calendar__filter-end">
              <div class="col-12 m-0"></div>
            </div>
            -->
            <div class="row calendar__filter">
              <div class="col-12 col-md-4">
                <label for="filterCategory">${language("FILTER_SELECT_CATEGORY")}</label>
                <select id="filterCategory" class="form-control">
                  <option value="${window.serverdata.configMeta.aim?.calendar?.localid}">Alle kategorier</option>
                </select>
              </div>
            </div>
          <div>
        </section>
        <section class="content">
            <div class="container" id="calendargridcontainer">
            ...
            </div>
        </section>
    `;
};

export const setCalendarList = (number, data) => {
	const meetplaecholder =
		window.serverdata.configMeta.aim.calendar.listMode !== "compact" && window.serverdata.configMeta.aim.calendar.listMode !== undefined
			? getMonthWithEvents(data)
			: getFullListOfEvents(data);

	let meetc = [];
	let meeti = 0;

	const meetmax = number;
	dayjs.extend(updateLocale);
	dayjs.updateLocale(
		"nb",
		{
			weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
		},
		"nn",
		{
			weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
		},
	);

	for (const calitem of meetplaecholder) {
		const from = dayjs(calitem.date);
		let dayPart = from.date();
		let datePart = from.format("MMM");
		if (window.serverdata.configMeta.aim.calendar.displayMode === 1) {
			dayPart = from.format("ddd");
			datePart = from.format("DD. MMM");
		}

		const time = from.format("HH:mm");

		if (meeti < meetmax) {
			meetc.push(`
            <div class="col-12 col-md-8 xcol-lg-6 mb-4">
                <div class="calendar__item">
                    <div class="row row-eq-height calendar__item_grid${window.serverdata.configMeta.aim.calendar.imagesInList ? " with-image" : ""}">
                        <div class="calendar__date-container">
                            <div class="cpcal__datespace h-100">
                                <span class="calendar__item__date">${dayPart}.</span>
                                <span class="calendar__item__month">${datePart}</span>
                            </div>
                        </div>
                        ${window.serverdata.configMeta.aim.calendar.imagesInList
					? `
                          <div class="calendar__image-container">
                            <div class="calendar__item__image" data-src="${calitem.image}"><img src="${calitem.image}" loading="lazy" /></div>
                          </div>`
					: ""
				}
                        <div class="calendar__info-container">
                            <div><a href="/${calitem.link}" class="calendar__item__link">${calitem.title}</a></div>
                            <div class="calendar__item__place-time">
                              ${calitem.place !== null && calitem.place !== ""
					? `<div><span class="material-icons-outlined notranslate calendar__item__icon calendar__item__icon-place"></span> ${calitem.place}</div>`
					: ""
				}
                              ${time !== null && time !== ""
					? `<div><span class="material-icons-outlined notranslate calendar__item__icon calendar__item__icon-time"></span> ${time}</div>`
					: ""
				}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            `);
		}
		meeti++;
	}

	meetc = meetc.join("");

	const meetLink = "";
	let meetcalender = "";
	const elmCalendarList = document.getElementById("calendarlistcontainer");
	if (meetplaecholder.length > 0) {
		meetcalender = `
            <div class="row justify-content-md-center" id="cp__meeting__cal">
                ${meetc}
            </div>
            <div class="row justify-content-md-center xjustify-content-lg-start mb-5">
                <div class="col-12 col-md-7 text-right">
                    ${meetLink}
                </div>
            </div>
        `;

		elmCalendarList.innerHTML = meetcalender;
		setImages();
		document.getElementById("fromDate").valueAsDate = new Date();
		let today = new Date();
		let dd = today.getDate();
		let mm = today.getMonth() + 1; // January is 0 so need to add 1 to make it 1!
		const yyyy = today.getFullYear();
		if (dd < 10) {
			dd = `0${dd}`;
		}
		if (mm < 10) {
			mm = `0${mm}`;
		}
		today = `${yyyy}-${mm}-${dd}`;
		document.getElementById("fromDate").min = today;

		const elmSearchBtn = document.getElementById("btnSearchForEvents");
		if (!elmSearchBtn.classList.contains("has-handler")) {
			elmSearchBtn.addEventListener("click", () => {
				elmSearchBtn.classList.add("has-handler");
				filterEvents();
			});
		}

		const elmFilterTxt = document.getElementById("filterText");
		if (!elmFilterTxt.classList.contains("has-handler")) {
			elmFilterTxt.addEventListener("keydown", (ev) => {
				const keyEvent = ev;
				elmFilterTxt.classList.add("has-handler");
				if (keyEvent.key === "Enter") {
					filterEvents();
				}
			});
		}

		const elmResetBtn = document.getElementById("resetLink");
		if (!elmResetBtn.classList.contains("has-handler")) {
			elmResetBtn.addEventListener("click", () => {
				elmResetBtn.classList.add("has-handler");
				document.getElementById("fromDate").value = "";
				document.getElementById("toDate").value = "";
				document.getElementById("filterText").value = "";
				document.getElementById("filterCategory").value = window.serverdata.configMeta.aim?.calendar?.localid;
				getEvents(_categoryId, (cal) => {
					setCalendarList(5, cal);
				});
			});
		}

		// const categorySelector = document.getElementById("filterCategory");
		// if (!categorySelector.classList.contains("has-handler")) {
		//   categorySelector.addEventListener("change", () => {
		//     categorySelector.classList.add("has-handler");
		//     filterByCategory(categorySelector.value, "list");
		//   });
		// }
	}
};
export const setCalendarGrid = (number, data) => {
	const meetplaecholder =
		window.serverdata.configMeta.aim.calendar.listMode !== "compact" && window.serverdata.configMeta.aim.calendar.listMode !== undefined
			? getMonthWithEvents(data, "event_custom/")
			: getFullListOfEvents(data, "event_custom/");

	let meetc = [];
	let meeti = 0;

	const meetmax = number;
	dayjs.extend(updateLocale);
	dayjs.updateLocale(
		"nb",
		{
			weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
		},
		"nn",
		{
			weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
		},
	);

	for (const calitem of meetplaecholder) {
		const from = dayjs(calitem.date);
		let dayPart = from.date();
		let datePart = from.format("MMM");
		const repeating = calitem.OverFlereDager || calitem.Repeterende;

		if (window.serverdata.configMeta.aim.calendar.displayMode === 1) {
			dayPart = from.format("ddd");
			dayPart = dayPart.charAt(0).toUpperCase() + dayPart.slice(1);
			datePart = from.format("DD. MMM");
		} else if (window.serverdata.configMeta.aim.calendar.displayMode === 2) {
			dayPart = from.format("dddd");
			dayPart = dayPart.charAt(0).toUpperCase() + dayPart.slice(1);
			datePart = from.format("DD. MMMM");
		}

		const time = from.format("HH:mm");

		if (meeti < meetmax) {
			meetc.push(`
                <a href="/${calitem.link}" class="calendargrid__item">
                  <div class="calendargrid__item${window.serverdata.configMeta.aim.calendar.imagesInList ? " with-image" : ""}">
                    ${window.serverdata.configMeta.aim.calendar.imagesInList
					? `
                      <div class="calendargrid__image-container">
                        <div class="calendar__item__image" data-src="${calitem.image}"><img src="${calitem.image}" loading="lazy"/></div>
                      </div>`
					: ""
				}
                    <div class="calendar__info-container">
                        <div class="event__item__link">${calitem.title}</div>
                        <div>
                          <p class="event__item__place">
                            <span class="material-icons-outlined notranslate calendar__item__icon calendar__item__icon-place"></span> 
                            ${calitem.place != null ? calitem.place : ""}
                          </p> 
                          <p class="event__item__time-stamp">
                            <span class="material-icons-outlined notranslate calendar__item__icon calendar__item__icon-date${repeating ? "-repeat" : ""}"></span>
                            ${dayPart} ${datePart} kl. ${time} ${repeating ? language("ACTIVITY_MORE_DATES") : ""}
                          </p>
                        </div>
                    </div>
                  </div>
                </a>
            `);
		}
		meeti++;
	}

	meetc = meetc.join("");

	const meetLink = "";
	let meetcalender = "";
	const elmCalendarList = document.getElementById("calendargridcontainer");
	if (meetplaecholder.length > 0) {
		meetcalender = `
            <div class="row justify-content-md-center" id="cp__meeting__cal">
              <div class="col-12 col-md-12 calendargrid">
                ${meetc}
              </div>
            </div>
            <div class="row justify-content-md-center xjustify-content-lg-start mb-5">
                <div class="col-12 col-md-12 text-right">
                    ${meetLink}
                </div>
            </div>
        `;

		elmCalendarList.innerHTML = meetcalender;
		setImages();

		// const categorySelector = document.getElementById("filterCategory");
		// categorySelector.addEventListener("change", () => {
		//   filterByCategory(categorySelector.value, "grid");
		// });
		const categorySelector = document.getElementById("filterCategory");
		if (!categorySelector.classList.contains("has-handler")) {
			categorySelector.addEventListener("change", () => {
				categorySelector.classList.add("has-handler");
				filterByCategory(categorySelector.value, "grid");
			});
		}
	}
};

const getFullListOfEvents = (data, preLink = "event/") => {
	const meetplaecholder = [];

	for (const item of data.FullListOfEvents) {
		const calObj = item.KalenderObjekt;
		const addr = item.Lokasjon;
		let calImageUrl = "";
		if (calObj.MedieFiler.length > 0) {
			calImageUrl = calObj.MedieFiler[0].SmallUrl;
		}
		meetplaecholder.push({
			link: preLink + calObj.Id,
			date: item.FraDato,
			title: item.Name,
			place: addr.Name !== null ? `${addr.Name}, ${addr.Adresse}` : `${addr.Adresse}`,
			image: calImageUrl,
			OverFlereDager: item.OverFlereDager,
			Repeterende: item.Repeterende,
		});
	}
	return meetplaecholder;
};
const getMonthWithEvents = (data, preLink = "event/") => {
	const meetplaecholder = [];

	for (const month of data.MonthWithEvents) {
		for (const day of month.DaysWithEvents) {
			for (const item of day.Events) {
				const calObj = item.KalenderObjekt;
				const addr = item.Lokasjon;
				let calImageUrl = "";
				if (calObj.MedieFiler.length > 0) {
					calImageUrl = calObj.MedieFiler[0].SmallUrl;
				}

				let tmpPlace = addr.Name !== null ? addr.Name : "";
				tmpPlace += addr.Adresse !== null ? ` - ${addr.Adresse}` : "";

				meetplaecholder.push({
					link: preLink + calObj.Id,
					date: item.FraDato,
					title: item.Name,
					place: tmpPlace,
					image: calImageUrl,
					OverFlereDager: item.OverFlereDager,
					Repeterende: item.Repeterende,
				});
			}
		}
	}
	return meetplaecholder;
};
const getCategories = (callback) => {
	const calendarNameId = window.serverdata.configMeta.aim.calendar.group;
	fetch(`https://sspkalender.prokom.no/api/kategori/?Kunde=${calendarNameId}`)
		.then((data) => data.json())
		.then((data) => {
			callback(data);
		});
};
const filterEvents = () => {
	const elmFromDate = document.getElementById("fromDate");
	const elmToDate = document.getElementById("toDate");
	const elmCategory = document.getElementById("filterCategory");
	let fromDate = "";
	let toDate = "";
	if (elmFromDate != null && elmFromDate?.value !== "") {
		fromDate = `${elmFromDate.value.split("-")[2]}.${elmFromDate.value.split("-")[1]}.${elmFromDate.value.split("-")[0]}`;
	}
	if (elmToDate != null && elmToDate?.value !== "") {
		toDate = `${elmToDate.value.split("-")[2]}.${elmToDate.value.split("-")[1]}.${elmToDate.value.split("-")[0]}`;
	}
	getFilteredEvents(elmCategory.value, fromDate, toDate, document.getElementById("filterText").value, window.serverdata.configMeta.aim.calendar.listMode, (cal) => {
		setCalendarList(100, cal);
		document.getElementById("calendarlistcontainer").scrollIntoView({
			behavior: "smooth",
			block: "start",
			inline: "nearest",
		});
	});
};
const filterByCategory = (categoryId, type) => {
	getFilteredEvents(categoryId, "", "", "", window.serverdata.configMeta.aim.calendar.listMode, (cal) => {
		switch (type) {
			case "list":
				setCalendarList(100, cal);
				break;
			case "grid":
				setCalendarGrid(100, cal);
				break;
			default:
				setCalendarList(100, cal);
		}
	});
};
